module.exports = __webpack_public_path__ + "fonts/Avenir-LightOblique.66d686a.woff2";